import ExclusiveAccordionList from "./ExclusiveAccordionList";
export default ExclusiveAccordionList;
